import { Pathname } from '@lyra/web/constants/pages'
import RouteLink from 'next/link'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

type Props = {
  href?: string
  children?: React.ReactNode
}

const NextLinkUnstyled = ({ href, children }: Props) => {
  const { prefetch } = useRouter()

  useEffect(() => {
    if (href && href.startsWith('/')) {
      prefetch(href as Pathname)
    }
  }, [prefetch, href])

  if (!href || !href.startsWith('/')) {
    return children
  }

  return (
    <RouteLink href={href} style={{ textDecoration: 'none' }} legacyBehavior>
      {children}
    </RouteLink>
  )
}

export default NextLinkUnstyled
